import { render } from "./PolicyEditOnboardComponent.vue?vue&type=template&id=afdfe368&scoped=true"
import script from "./PolicyEditOnboardComponent.vue?vue&type=script&lang=js"
export * from "./PolicyEditOnboardComponent.vue?vue&type=script&lang=js"

import "./PolicyEditOnboardComponent.vue?vue&type=style&index=0&id=afdfe368&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afdfe368"]])

export default __exports__